/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Fields/view.blocks to change it.
import Description from './Description/index'
import Number from './Number/index'
import React from 'react'
import Type from './Type/index'



/** @type {import('Simple/types.js').View} */
export default function Fields({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/NewPhone/Content/NewRelation/Add/Content/Phone/Fields"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Fields.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Number
  viewPath={`${viewPath}/Number`}
/>
<Type
  viewPath={`${viewPath}/Type`}
/>
<Description
  viewPath={`${viewPath}/Description`}
/>
</div>
{children}
</React.Fragment>)
}